import { ISettingsGeorgeBusinessResponse } from "types/settings";
import { ITypedAPITarget } from "./NetworkStapler";
import { ICard, ICardResult, ILoyaltyDataResponse, IPayCardFeeInMilesDetailResponse, IPayCardFeeInMilesPutResponse, ITeamCardLinkageSMSOtpResponse } from "types/card";
import { ITeamcardLinkageInvitationMatch } from "types/teamcardLinkage";
import authStore from "stores/AuthStore";

export function getSettings(): ITypedAPITarget<ISettingsGeorgeBusinessResponse> {
    return {
        url: "/my/settings",
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: json => json as ISettingsGeorgeBusinessResponse
    };
}

export function getCards(filterFor?: string): ITypedAPITarget<ICard[]> {
    const queryParameters: any = {
        featureSet: "ALL_NO_EXTERNAL_BALANCES_NO_MISC_NOT_PRODUCED",
    };

    if (filterFor) {
        queryParameters.filterFor = filterFor;
    }

    return {
        url: "/my/cards",
        headers: {
            "Accept": "*/*"
        },
        queryParameters,
        parse: (json) => {
            return (json as any).cards as ICard[];
        }
    };
}

export function getCard(cardId: string): ITypedAPITarget<ICardResult> {
    return {
        url: "/my/cards/" + cardId,
        headers: {
            "Accept": "*/*"
        },
        queryParameters: {
            featureSet: "ALL_NO_EXTERNAL_BALANCES_NO_MISC_NOT_PRODUCED"
        },
        parse: (json) => {
            return json as ICardResult;
        }
    };
}

export function getLoyalty(cardId: string): ITypedAPITarget<ILoyaltyDataResponse> {
    return {
        url: "/my/cards/" + cardId + "/loyalty",
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: (json: any) => {
            return json as ILoyaltyDataResponse;
        }
    };
}

export function getPayCardFeeInMilesDetail(
    cardId: string
): ITypedAPITarget<IPayCardFeeInMilesDetailResponse> {
    return {
        url:
            "/my/cards/" +
            cardId +
            "/loyalty/MILES_AND_MORE_PAY_CARD_FEE_IN_MILES",
        headers: {
            Accept: "application/json",
        },
        method: "GET",
        parse: (json: any) => json as IPayCardFeeInMilesDetailResponse,
    };
}

export function putPayCardFeeInMiles(
    cardId: string,
    body: { payCardsFeeInMilesActivated: boolean }
): ITypedAPITarget<IPayCardFeeInMilesPutResponse> {
    return {
        url:
            "/my/cards/" +
            cardId +
            "/loyalty/MILES_AND_MORE_PAY_CARD_FEE_IN_MILES",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        method: "PUT",
        body,
        parse: (json: any) => json as IPayCardFeeInMilesPutResponse,
    };
}

export function postInvitationsMatch(invitationId: string): ITypedAPITarget<ITeamcardLinkageInvitationMatch> {
    return {
        url: `/invitations/${invitationId}/match`,
        headers: {
            "Accept": "application/json"
        },
        method: "POST",
        parse: (json) => {
            return json as ITeamcardLinkageInvitationMatch;
        }
    };
}

export function postTeamCardLinkageSMSOtp(invitationId: string): ITypedAPITarget<ITeamCardLinkageSMSOtpResponse> {
    return {
        url: `/invitations/${invitationId}/mfa/sms `,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        method: "POST",
        body: {
            language: authStore.locale,
        },
        parse: json => json as ITeamCardLinkageSMSOtpResponse

    };
}

export function postTeamCardLinkageSMSOtpVerify(invitationId: string, mfaKey: string, communicationId: string): ITypedAPITarget<ITeamCardLinkageSMSOtpResponse> {
    return {
        url: `/invitations/${invitationId}/mfa/sms/verify`,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        method: "POST",
        body: {
            mfaKey,
            communicationId
        },
        parse: json => json as ITeamCardLinkageSMSOtpResponse
    };
}




// WEBPACK FOOTER //
// ./src/network/GeorgeBusinessAPI.ts